import React from "react";
import { useLocation } from "react-router-dom"; 
import BlueTriangle from "../assets/icons/BlueTriangle.png";
import PurpleTriangle from "../assets/icons/PurpleTriangle.png";
import OrangeTriangle from "../assets/icons/OrangeTriangle.png";
import { ServiceStatsCardsCard, ServiceStatsCardsContainer, ServiceStatsCardsNumber, ServiceStatsCardsText, ServiceStatsCardsTitle, ServiceStatsCardsTriangleIcon, ServiceStatsCardsWrapper } from "../assets/styles/CommonStyles";



const ServiceStatsCards = () => {
  const location = useLocation();

  const isInstantChecks = location.pathname.includes("instant-checks");
  const isBackgroundChecks = location.pathname.includes("background-checks");
  const isDueDiligence = location.pathname.includes("due-diligence");

  const instantChecksCardsData = [
    { number: "80+", text: "Trusted APIs", color: "#909FFB",hoverBgColor:"#909FFB", image: BlueTriangle },
    { number: "2x", text: "Faster Onboarding", color: "#D279FF",hoverBgColor:"#D279FF", image: PurpleTriangle },
    { number: "100%", text: "Compliant", color: "#FFBD6C",hoverBgColor:"#FFBD6C", image: OrangeTriangle },
  ];

  const backgroundChecksCardsData = [
    { number: "95%", text: "SLA Compliance", color: "#909FFB",hoverBgColor:"#909FFB",  image: BlueTriangle },
    { number: "100%", text: "Quality Assurance", color: "#D279FF",hoverBgColor:"#D279FF",  image: PurpleTriangle },
    { number: "97%", text: "Written Reverts", color: "#FFBD6C",hoverBgColor:"#FFBD6C",  image: OrangeTriangle },
  ];

  const dueDiligenceCardsData = [
    { number: "2x", text: "Faster Onboarding", color: "#909FFB",hoverBgColor:"#909FFB", image: BlueTriangle },
    { number: "360°", text: "Quality Assurance", color: "#D279FF", hoverBgColor:"#D279FF",image: PurpleTriangle },
    { number: "100%", text: "Visibility of Risk Parameters", color: "#FFBD6C",hoverBgColor:"#FFBD6C", image: OrangeTriangle },
  ];

  const cardsData = isInstantChecks
    ? instantChecksCardsData
    : isBackgroundChecks
    ? backgroundChecksCardsData
    : isDueDiligence
    ? dueDiligenceCardsData
    : instantChecksCardsData;

  const title = isInstantChecks
    ? "Why Choose Instant Checks?"
    : isBackgroundChecks
    ? "Why Choose Devia?"
    : isDueDiligence
    ? "Key Highlights"
    : "Why Choose Our Services?";

  return (
    <ServiceStatsCardsContainer>
      <ServiceStatsCardsTitle>{title}</ServiceStatsCardsTitle>
      <ServiceStatsCardsWrapper>
        {cardsData.map((card, index) => (
          <ServiceStatsCardsCard key={index} hoverBgColor={card.hoverBgColor}>
          <ServiceStatsCardsNumber color={card.color}>
            {card.number.includes("°") ? (
              <>
                {card.number.split("°")[0]}
                <span className="degree-symbol">°</span>
              </>
            ) : (
              card.number
            )}
          </ServiceStatsCardsNumber>
            <ServiceStatsCardsText>{card.text}</ServiceStatsCardsText>
            <ServiceStatsCardsTriangleIcon src={card.image} alt="Triangle" />
          </ServiceStatsCardsCard>
        ))}
      </ServiceStatsCardsWrapper>
    </ServiceStatsCardsContainer>
  );
};

export default ServiceStatsCards;
